import { Divider, Modal } from 'antd';

export const showUploadErrorModal = (
  t: (key: string, options?: any) => string,
  errorMessage: string,
  fileName: string
) => {
  const systemTitle = (window as any).systemTitle || t('system.title');

  Modal.error({
    content: (
      <div>
        <span>{t('upload.fileUploadFailed', { fileName })}</span>
        <Divider orientation={'left'}>
          <span style={{ fontSize: '12px' }}>{t('upload.errorDetails')}</span>
        </Divider>
        <span>{errorMessage}</span>
        <Divider orientation={'left'}>
          <span style={{ fontSize: '12px' }}>{t('upload.buyVipTitle')}</span>
        </Divider>
        <span style={{ color: 'red' }}>
          1. <a href={'https://c.fakamiao.top/shopDetail/Wte5t6'} target={'_blank'} rel={'noreferrer'}>{t('upload.buyVipStep1')}</a>{' '}
          <a href={'https://www.zhufaka.cn/shop/R8QB4K01'} target={'_blank'} rel={'noreferrer'}>{t('upload.buyVipStep1Alt')}</a>
          2. {t('upload.buyVipStep2')}
          3. {t('upload.buyVipStep3', { systemTitle })} {t('login.login')}
          4. {t('upload.buyVipStep4')}
          5. {t('upload.buyVipStep5')}
        </span>
        <Divider orientation={'left'}>
          <span style={{ fontSize: '12px' }}>{t('upload.moreSupport')}</span>
        </Divider>
        <img
          style={{ margin: '0 auto', display: 'block' }}
          src={'https://z.wiki/autoupload/20250503/OG1U/1126X1494/mmqrcode1746280934239.png'}
          width={'257px'}
          height={'257px'}
          alt={t('upload.moreSupport')}
        />
      </div>
    ),
    title: t('upload.uploadFailed'),
  });
};
